import { getCreditBatches } from '../../../api/creditBatchApi'
import CreditBatchSearchFilter from '../../../components/credit-batches/credit-batch-filter/credit-batch-filter'
import CreditBatchesList from '../../../components/credit-batches/credit-batches-list/credit-batches-list'
import { getSearchParams, getSearchValues } from '../../../helpers/utils'
import { PageInfo } from '../../../share-types'
import {
  CreditBatchFilter,
  CreditBatchOrderBy,
  ICreditBatch,
  ICreditBatchFilterParams,
} from '../share-type'
import { Card, Space } from 'antd'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

const defaultPageInfo: PageInfo = { currentPage: 1, pageSize: 10, count: 0 }

const CreditBatches = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const [creditBatches, setCreditBatches] = useState<ICreditBatch[]>([])
  const [pageInfo, setPageInfo] = useState<PageInfo>(defaultPageInfo)
  const [searchValues, setSearchValues] = useState<ICreditBatchFilterParams>()

  const loadCreditBatches = (params: CreditBatchFilter) => {
    getCreditBatches(params).then(response => {
      setCreditBatches(response.data)
      setPageInfo({ ...response.pageInfo, currentPage: response.pageInfo.currentPage + 1 })
    })
  }

  useEffect(() => {
    const values = getSearchValues(
      [
        { key: 'id', isBoolean: false },
        { key: 'userId', isBoolean: false },
        { key: 'sourceType', isBoolean: false },
        { key: 'sourceId', isBoolean: false },
        { key: 'status', isBoolean: false },
        { key: 'expiresAtFrom', isBoolean: false },
        { key: 'expiresAtTo', isBoolean: false },
        { key: 'orderBy', isBoolean: false, default: CreditBatchOrderBy.CREATED_AT },
        { key: 'size', isBoolean: false, default: defaultPageInfo.pageSize },
        { key: 'page', isBoolean: false, default: defaultPageInfo.currentPage - 1 },
      ],
      searchParams,
    )
    const data: CreditBatchFilter = {
      ...values,
      id: values.id ? Number(values.id) : undefined,
      userId: values.userId ? Number(values.userId) : undefined,
      sourceId: values.sourceId ? Number(values.sourceId) : undefined,
      page: Number(values.page),
      size: Number(values.size),
    }
    setSearchValues(data)
    loadCreditBatches(data)
  }, [])

  const onPaginationChange = (page: number, pageSize: number) => {
    const data: CreditBatchFilter = { ...searchValues, page: page - 1, size: pageSize }
    setSearchParams(getSearchParams(data))
    loadCreditBatches(data)
  }

  const onSearch = (value: ICreditBatchFilterParams) => {
    const data: CreditBatchFilter = { ...value, page: 0, size: pageInfo.pageSize }
    setSearchValues(value)
    setSearchParams(getSearchParams(data))
    loadCreditBatches(data)
  }

  return (
    <Card>
      <Space orientation="vertical" size="middle" style={{ width: '100%' }}>
        <CreditBatchSearchFilter formData={searchValues} onSearch={onSearch} />
        <CreditBatchesList
          creditBatches={creditBatches}
          pagination={{
            current: pageInfo.currentPage,
            pageSize: pageInfo.pageSize,
            total: pageInfo.count,
            showSizeChanger: true,
          }}
          onPaginationChange={onPaginationChange}
        />
      </Space>
    </Card>
  )
}

export default CreditBatches
